// Login.jsx
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import styles from "./styles/Login.module.css";
import FormWrapper from "./components/FormWrapper";
import LeftWrapper from "./components/LeftWrapper";
import { login } from "../../api/Auth/auth";

const Login = React.memo(({ setIsLoggedIn }) => {
  const [formCreds, setFormCreds] = useState({
    email: "",
    password: "",
    loading: false,
    showPassword: false,
    error: "",
  });

  const navigate = useNavigate();

  const loginHandle = async (e) => {
    e.preventDefault();
    if (formCreds.loading) return;

    setFormCreds((s) => ({ ...s, loading: true, error: "" }));

    const { ok, error } = await login(
      formCreds.email.trim(),
      formCreds.password
    );

    if (ok) {
      setIsLoggedIn(true);
      navigate("/dashboard");
    } else {
      setFormCreds((s) => ({ ...s, error }));
    }

    setFormCreds((s) => ({ ...s, loading: false }));
  };

  return (
    <div className={styles.loginWrapper}>
      <LeftWrapper />
      <FormWrapper
        formCreds={formCreds}
        setFormCreds={setFormCreds}
        onSubmit={loginHandle}
      />
    </div>
  );
});

export default Login;
